const PropTypes = require('prop-types');

const React = require('react');
const moment = require('moment');
// @ components
const DateFilter = require('components/commons/dateFilter/dateFilter');
const OKModal = require('components/commons/OKModal/OKModal');
// @ constants
const { GENERAL_DATA: { PAST_DATE: { YEAR, DAY } } } = require('constants/mortgageRequestMortgageDataTypes');
const { DATE_FORMAT_API } = require('constants/index');
// @utils
const { recordLinkV2 } = require("utilities/tagging");
// @utilities
const { commonCatalogueFilters, commonFilterAnalyticsId } = require( '../../../../utilities/taggingCommonCatalogue' );
class MortgageRequestUnpaidFeesFilter extends React.Component {
    constructor(props) {
        super(props);

        const { immFilter } = props;

        this.state = {
            dateSelected: immFilter.getIn(['date','selected']),
            dateFrom: immFilter.getIn(['date','from']),
            dateTo: immFilter.getIn(['date','to'])
        };

        this.handleFiler = this.handleFiler.bind(this);
        this.handleChangeDateMin = this.handleChangeDateMin.bind(this);
        this.handleChangeDateMax = this.handleChangeDateMax.bind(this);
        this.handleChangeDateSelected = this.handleChangeDateSelected.bind(this);
        this.handleCancelModal = this.handleCancelModal.bind(this);
        this.handleCloseModal = this.handleCloseModal.bind(this);
    }


    componentDidUpdate(prevProps) {
        const { isOpen } = this.props;

        if(prevProps.isOpen !== isOpen && isOpen){
            recordLinkV2(commonCatalogueFilters[commonFilterAnalyticsId.OPEN_MODAL]());
        }
    }

    handleChangeDateMax(dateTo) {
        this.setState({
            dateTo
        });
    }

    handleChangeDateMin(dateFrom) {
        this.setState({
            dateFrom
        });
    }

    handleChangeDateSelected(dateSelected) {
        recordLinkV2(commonCatalogueFilters[commonFilterAnalyticsId.SELECT_DATE](dateSelected));
        this.setState({
            dateSelected
        });
    }

    handleFiler() {
        const { setFilter } = this.props;
        const { dateFrom, dateTo, dateSelected } = this.state;
        recordLinkV2(commonCatalogueFilters[commonFilterAnalyticsId.FILTER_BUTTON]());
        setFilter({
            selected: dateSelected,
            from: dateFrom,
            to: dateTo
        });
    }

    handleCancelModal() {
        const { onCloseClick } = this.props;
        recordLinkV2(commonCatalogueFilters[commonFilterAnalyticsId.CANCEL_BUTTON]());
        onCloseClick();
    }

    handleCloseModal() {
        const { onCloseClick } = this.props;
        recordLinkV2(commonCatalogueFilters[commonFilterAnalyticsId.CLOSE_MODAL]());
        onCloseClick();
    }

    render() {
        const { immFilter, immLoan, isOpen, isAresFlag } = this.props;
        const minDate = !!immLoan.get('openingDate') ? moment(immLoan.get('openingDate')).startOf('day') : moment(`${YEAR}-1-${DAY}`, DATE_FORMAT_API).startOf('day')
        const content = (
            <DateFilter
                immFilter={immFilter.get('date')}
                last={true}
                onChangeMin={this.handleChangeDateMin}
                onChangeMax={this.handleChangeDateMax}
                onChangeSelected={this.handleChangeDateSelected}
                minDate={minDate}
                showFortnightly={false}
                showMonthly={false}
                showThreeMonths={true}
                dateLabelTitle={isAresFlag ? "Por fecha" : null}
            />
        );

        return (
            <OKModal
                content={content}
                footerType="navigation"
                isOpen={isOpen}
                onCloseCallback={this.handleCloseModal}
                onPrimaryButtonClick={this.handleFiler}
                onSecondaryButtonClick={this.handleCancelModal}
                primaryButtonText="loansMovementsFilters-filter"
                secondaryButtonText="filterDate-cancel"
                title="mortgageRequestUnpaidFees-filterTitle"
            />
        );
    }
}

MortgageRequestUnpaidFeesFilter.propTypes = {
    onCloseClick: PropTypes.func.isRequired,
    isOpen: PropTypes.bool.isRequired,
    immFilter: PropTypes.object,
    setFilter: PropTypes.func,
    immLoan: PropTypes.object,
    isAresFlag: PropTypes.bool
};

module.exports = MortgageRequestUnpaidFeesFilter;
